import { Module } from 'vuex-smart-module';
import Equipment from '@/modules/purchase-orders/store/modules/equipment';
import Files from '@/modules/purchase-orders/store/modules/files';
import PurchaseOrdersActions from './actions';
import PurchaseOrdersGetters from './getters';
import PurchaseOrdersMutations from './mutaitons';
import PurchaseOrdersState from './state';

export default new Module({
  state: PurchaseOrdersState,
  mutations: PurchaseOrdersMutations,
  actions: PurchaseOrdersActions,
  getters: PurchaseOrdersGetters,
  modules: {
    equipment: Equipment,
    files: Files,
  },
});
